import { createStyles, makeStyles } from '@material-ui/styles'
import colors from 'shared/style/colors'

export const useStyles = makeStyles(() =>
  createStyles({
    footer: {
      '@media print': {
        display: 'none'
      },
      backgroundColor: colors.footer,
      width: '100%'
    }
  })
)
